import Base from '@studiometa/js-toolkit/abstracts/Base';
import withIntersectionObserver from '@studiometa/js-toolkit/decorators/withIntersectionObserver';

/**
 * Scroll component
 *
 * @usage data-component="Scroll" to add a scroll reveal animation
 * @options anim: fade|title
 */
export default class Scroll extends withIntersectionObserver(Base, { threshold: 0.5 }) {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'Scroll',
    };
  }

  /**
   * Triggered when the root element of the component is intersecting.
   * @param  {Array<IntersectionObserverEntry>} entries
   */
  intersected([entry]) {
    if (entry.isIntersecting) {
      requestAnimationFrame(() => {
        this.$el.classList.add('in-view');
        this.$destroy();
      });
    }
  }
}
